import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  folderController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$uibModalInstance',
    '$filter',
    'treeFolder',
    'isEdit',
    'folderModel',
    'folderService',
    '$uibModal',
    'PermPermissionStore',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      $uibModalInstance,
      $filter,
      treeFolder,
      isEdit,
      Folder,
      folderService,
      uibModal,
      PermPermissionStore
    ) {
      'use strict';

      function initialize() {
        $scope.isLoading = true;
        folderService
          .loadFolder($scope.idFolder)
          .then((folder) => {
            if ($scope.isEdit) {
              folder.hasChildren = $scope.treeFolder.HasChildren;
              folder.children = $scope.treeFolder.Children;
              folder.hasPermission = $scope.treeFolder.HasPermission;
              folder.canManageFolder = true;
              folder.features = $scope.treeFolder.Features;
              $scope.originalInheritAcronym = folder.inheritAcronym;
              $scope.folder = folder;
              $scope.folderCache[folder.idParent] = folder.parent;
            } else {
              if (PermPermissionStore.hasPermissionDefinition('WORKFLOW'))
                $scope.isCheck = true;
              $scope.folder.parent = folder;
              $scope.folderCache[folder.id] = folder;
              $scope.folder.inheritAcronym = folder.inheritAcronym;
              if (folder.inheritAcronym) {
                $scope.folder.acronym = folder.acronym;
              }
            }
            $scope.isLoading = false;
          })
          .catch((error) => {
            swal.fire({
              title: error.title,
              text: error.text,
              icon: 'error',
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
              preConfirm: () => {
                return new Promise((resolve) => {
                  $uibModalInstance.dismiss('cancel');
                  resolve();
                });
              },
            });
          });
      }

      function pickFolder() {
        var idNotShow = $scope.folder.id;

        $scope.pickFolderValidation = false;

        var modal = uibModal.open({
          animation: true,
          templateUrl: '/views/partials/pickFolder.html',
          controller: 'pickFolderController',
          backdrop: 'static',
          keyboard: true,
          size: 'sm',
          resolve: {
            treeSendFiles: () => false,
            canSelectRepository: () => true,
            idFolderNotShow: () => idNotShow,
          },
        });

        modal.result.then((folder) => {
          if ($scope.folderCache[$scope.folder.idParent].id !== folder.Id) {
            $scope.pickFolderValidation = true;
          }

          if ($scope.folderCache[folder.Id]) {
            $scope.folder.parent = $scope.folderCache[folder.Id];
          } else {
            $scope.isLoading = true;
            folderService.loadFolder(folder.Id).then(function (newParent) {
              $scope.folder.parent = newParent;
              $scope.folderCache[newParent.id] = newParent;
              $scope.folder.inheritAcronym = newParent.inheritAcronym;
              if (newParent.inheritAcronym) {
                $scope.folder.acronym = newParent.acronym;
              }
            });
            $scope.isLoading = false;
          }
        });
      }

      function canInheritAcronym() {
        return $scope.folder.parent && $scope.folder.parent.idParent;
      }

      function verifyInheritAcronym() {
        if (
          $scope.isEdit &&
          $scope.folder.inheritAcronym !== $scope.originalInheritAcronym &&
          $scope.folder.hasChildren
        ) {
          swal
            .fire({
              title: $filter('translate')('CONFIRM CHANGE ACRONYM'),
              text: $filter('translate')('SUBFOLDERS CAN CHANGE ACRONYM'),
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: $filter('translate')('YES'),
              cancelButtonText: $filter('translate')('NO'),
            })
            .then(() => {
              if ($scope.folder.inheritAcronym) {
                $scope.oldAcronym = $scope.folder.acronym;
                $scope.folder.acronym = $scope.folder.parent.acronym;
              } else {
                $scope.folder.acronym = $scope.oldAcronym;
              }
              $scope.$apply();
            })
            .catch(() => {
              $scope.folder.inheritAcronym = !$scope.folder.inheritAcronym;
              $scope.$apply();
            });
        } else {
          $scope.oldAcronym = $scope.folder.acronym;
          $scope.folder.acronym = $scope.folder.parent.acronym;
        }
      }

      function cancel() {
        $scope.messageTitle = $filter('translate')(
          $scope.isEdit
            ? 'CONFIRM CANCEL EDIT FOLDER'
            : 'CONFIRM CANCEL NEW FOLDER'
        );
        $scope.messageForward = $filter('translate')('YES');
        $scope.messageCancel = $filter('translate')('NO');

        $scope.modalQuestion = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/questionModal/questionModal.html',
          controller: 'folderController',
          size: 'small',
          windowClass: 'modal-remove',
          resolve: {
            treeFolder: treeFolder,
            isEdit: isEdit,
          },
        });
      }

      function questionModal() {
        $scope.modalQuestion.close();

        $rootScope.editFolderModal.close();
      }

      function cancelButton() {
        $scope.modalQuestion.close();
      }

      function canSave() {
        if ($scope.pickFolderValidation) {
          $scope.saveKeepingPermissions();
        } else {
          $scope.save();
        }
      }

      function saveKeepingPermissions() {
        $scope.$parent.modelState = null;

        swal.fire({
          title: $filter('translate')('WAIT SAVING'),
          text: $filter('translate')('WAIT SAVING MSG'),
          showConfirmButton: false,
          icon: 'info',
        });

        folderService
          .saveKeepingPermissions($scope.folder)
          .then((folder) => {
            swal.close();
            folder.hasChildren = $scope.isEdit
              ? $scope.treeFolder.HasChildren
              : false;
            folder.children = $scope.isEdit ? $scope.treeFolder.Children : null;
            folder.hasPermission = $scope.treeFolder.HasPermission;
            folder.canManageFolder = true;
            folder.features = $scope.treeFolder.Features;
            $uibModalInstance.close(folder);
          })
          .catch((error) => {
            $scope.$parent.modelState = error.modelState;
            if ($scope.$parent.modelState && $scope.new) {
              $scope.new.$setValidity('new.$error.modelState', false);
            }

            swal.fire({
              title: error.title,
              text: error.text,
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          });

        $scope.save();
      }

      function save() {
        var checkBox = document.getElementById('selectWorkflow');
        if (checkBox !== null) {
          $scope.workflow = checkBox.checked === true ? true : false;
        }
        $scope.$parent.modelState = null;

        swal.fire({
          title: $filter('translate')('WAIT SAVING'),
          text: $filter('translate')('WAIT SAVING MSG'),
          showConfirmButton: false,
          icon: 'info',
        });

        folderService
          .save($scope.folder, $scope.workflow)
          .then((folder) => {
            swal.close();

            folder.hasChildren = $scope.isEdit
              ? $scope.treeFolder.HasChildren
              : false;
            folder.children = $scope.isEdit ? $scope.treeFolder.Children : [];
            folder.hasPermission = $scope.treeFolder.HasPermission;
            folder.canManageFolder = true;
            folder.canCreateFolder = true;
            folder.features = $scope.treeFolder.Features;

            if (folder.parent !== undefined && !folder.parent.hasChildren)
              folder.parent.hasChildren = true;

            $uibModalInstance.close(folder);
          })
          .catch((error) => {
            $scope.$parent.modelState = error.modelState;
            if ($scope.$parent.modelState && $scope.new) {
              $scope.new.$setValidity('new.$error.modelState', false);
            }

            swal.fire({
              title: error.title,
              text: error.text,
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          });
      }

      function validityModelState(keyToClear) {
        var isValid = true;
        var BreakException = {};
        try {
          if ($scope.modelState) {
            if ($scope.modelState[keyToClear]) {
              $scope.modelState[keyToClear] = [];
            }
            Object.keys($scope.modelState).forEach((key) => {
              if (!key.startsWith('$') && $scope.modelState[key].length > 0) {
                isValid = false;
                throw BreakException;
              }
            });
          }
        } catch (e) {
          if (e !== BreakException) throw e;
        }
        if ($scope.new) {
          isValid
            ? $scope.new.$setValidity('new.$error.modelState', true)
            : $scope.new.$setValidity('new.$error.modelState', false);
        }
      }

      function run() {
        try {
          $scope.treeFolder = treeFolder;
          $scope.idFolder = treeFolder.Id;
          $scope.folder = new Folder();
          $scope.isLoading = false;
          $scope.isEdit = isEdit;
          $scope.folderCache = [];
          $scope.workflow = false;
          $scope.isCheck = false;

          $scope.pickFolderValidation = false;

          $scope.initialize = logWrapper(
            initialize,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.pickFolder = logWrapper(
            pickFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canInheritAcronym = logWrapper(
            canInheritAcronym,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.verifyInheritAcronym = logWrapper(
            verifyInheritAcronym,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancel = logWrapper(
            cancel,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.questionModal = logWrapper(
            questionModal,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelButton = logWrapper(
            cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSave = logWrapper(
            canSave,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.saveKeepingPermissions = logWrapper(
            saveKeepingPermissions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.save = logWrapper(
            save,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.validityModelState = logWrapper(
            validityModelState,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
